/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as WithAppbarRouteImport } from './routes/_with-appbar'
import { Route as WithAppbarDocumentsIndexRouteImport } from './routes/_with-appbar/documents/index'
import { Route as WithAppbarErrorIndexRouteImport } from './routes/_with-appbar/error/index'
import { Route as WithAppbarOkIndexRouteImport } from './routes/_with-appbar/ok/index'
import { Route as WithAppbarOtpIndexRouteImport } from './routes/_with-appbar/otp/index'
import { Route as WithAppbarSuccessVideoIndexRouteImport } from './routes/_with-appbar/success-video/index'

const homeIndexLazyRouteImport = createFileRoute('/(home)/')()
const WithAppbarErrorParamIdLazyRouteImport = createFileRoute(
  '/_with-appbar/error/$paramId',
)()
const WithAppbarPaymentDetailsIndexLazyRouteImport = createFileRoute(
  '/_with-appbar/payment-details/',
)()
const WithAppbarPensionIndexLazyRouteImport = createFileRoute(
  '/_with-appbar/pension/',
)()
const WithAppbarUploadIdentityDocumentIndexLazyRouteImport = createFileRoute(
  '/_with-appbar/upload-identity-document/',
)()

const WithAppbarRoute = WithAppbarRouteImport.update({
  id: '/_with-appbar',
  getParentRoute: () => rootRouteImport,
} as any)
const homeIndexLazyRoute = homeIndexLazyRouteImport
  .update({
    id: '/(home)/',
    path: '/',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(home)/index.lazy').then((d) => d.Route))
const WithAppbarDocumentsIndexRoute =
  WithAppbarDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => WithAppbarRoute,
  } as any).lazy(() =>
    import('./routes/_with-appbar/documents/index.lazy').then((d) => d.Route),
  )
const WithAppbarErrorIndexRoute = WithAppbarErrorIndexRouteImport.update({
  id: '/error/',
  path: '/error/',
  getParentRoute: () => WithAppbarRoute,
} as any)
const WithAppbarErrorParamIdLazyRoute =
  WithAppbarErrorParamIdLazyRouteImport.update({
    id: '/error/$paramId',
    path: '/error/$paramId',
    getParentRoute: () => WithAppbarRoute,
  } as any).lazy(() =>
    import('./routes/_with-appbar/error/$paramId.lazy').then((d) => d.Route),
  )
const WithAppbarOkIndexRoute = WithAppbarOkIndexRouteImport.update({
  id: '/ok/',
  path: '/ok/',
  getParentRoute: () => WithAppbarRoute,
} as any)
const WithAppbarOtpIndexRoute = WithAppbarOtpIndexRouteImport.update({
  id: '/otp/',
  path: '/otp/',
  getParentRoute: () => WithAppbarRoute,
} as any).lazy(() =>
  import('./routes/_with-appbar/otp/index.lazy').then((d) => d.Route),
)
const WithAppbarPaymentDetailsIndexLazyRoute =
  WithAppbarPaymentDetailsIndexLazyRouteImport.update({
    id: '/payment-details/',
    path: '/payment-details/',
    getParentRoute: () => WithAppbarRoute,
  } as any).lazy(() =>
    import('./routes/_with-appbar/payment-details/index.lazy').then(
      (d) => d.Route,
    ),
  )
const WithAppbarPensionIndexLazyRoute =
  WithAppbarPensionIndexLazyRouteImport.update({
    id: '/pension/',
    path: '/pension/',
    getParentRoute: () => WithAppbarRoute,
  } as any).lazy(() =>
    import('./routes/_with-appbar/pension/index.lazy').then((d) => d.Route),
  )
const WithAppbarSuccessVideoIndexRoute =
  WithAppbarSuccessVideoIndexRouteImport.update({
    id: '/success-video/',
    path: '/success-video/',
    getParentRoute: () => WithAppbarRoute,
  } as any)
const WithAppbarUploadIdentityDocumentIndexLazyRoute =
  WithAppbarUploadIdentityDocumentIndexLazyRouteImport.update({
    id: '/upload-identity-document/',
    path: '/upload-identity-document/',
    getParentRoute: () => WithAppbarRoute,
  } as any).lazy(() =>
    import('./routes/_with-appbar/upload-identity-document/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof homeIndexLazyRoute
  '/error/$paramId': typeof WithAppbarErrorParamIdLazyRoute
  '/documents/': typeof WithAppbarDocumentsIndexRoute
  '/error/': typeof WithAppbarErrorIndexRoute
  '/ok/': typeof WithAppbarOkIndexRoute
  '/otp/': typeof WithAppbarOtpIndexRoute
  '/success-video/': typeof WithAppbarSuccessVideoIndexRoute
  '/payment-details/': typeof WithAppbarPaymentDetailsIndexLazyRoute
  '/pension/': typeof WithAppbarPensionIndexLazyRoute
  '/upload-identity-document/': typeof WithAppbarUploadIdentityDocumentIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof homeIndexLazyRoute
  '/error/$paramId': typeof WithAppbarErrorParamIdLazyRoute
  '/documents': typeof WithAppbarDocumentsIndexRoute
  '/error': typeof WithAppbarErrorIndexRoute
  '/ok': typeof WithAppbarOkIndexRoute
  '/otp': typeof WithAppbarOtpIndexRoute
  '/success-video': typeof WithAppbarSuccessVideoIndexRoute
  '/payment-details': typeof WithAppbarPaymentDetailsIndexLazyRoute
  '/pension': typeof WithAppbarPensionIndexLazyRoute
  '/upload-identity-document': typeof WithAppbarUploadIdentityDocumentIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_with-appbar': typeof WithAppbarRouteWithChildren
  '/(home)/': typeof homeIndexLazyRoute
  '/_with-appbar/error/$paramId': typeof WithAppbarErrorParamIdLazyRoute
  '/_with-appbar/documents/': typeof WithAppbarDocumentsIndexRoute
  '/_with-appbar/error/': typeof WithAppbarErrorIndexRoute
  '/_with-appbar/ok/': typeof WithAppbarOkIndexRoute
  '/_with-appbar/otp/': typeof WithAppbarOtpIndexRoute
  '/_with-appbar/success-video/': typeof WithAppbarSuccessVideoIndexRoute
  '/_with-appbar/payment-details/': typeof WithAppbarPaymentDetailsIndexLazyRoute
  '/_with-appbar/pension/': typeof WithAppbarPensionIndexLazyRoute
  '/_with-appbar/upload-identity-document/': typeof WithAppbarUploadIdentityDocumentIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error/$paramId'
    | '/documents/'
    | '/error/'
    | '/ok/'
    | '/otp/'
    | '/success-video/'
    | '/payment-details/'
    | '/pension/'
    | '/upload-identity-document/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error/$paramId'
    | '/documents'
    | '/error'
    | '/ok'
    | '/otp'
    | '/success-video'
    | '/payment-details'
    | '/pension'
    | '/upload-identity-document'
  id:
    | '__root__'
    | '/_with-appbar'
    | '/(home)/'
    | '/_with-appbar/error/$paramId'
    | '/_with-appbar/documents/'
    | '/_with-appbar/error/'
    | '/_with-appbar/ok/'
    | '/_with-appbar/otp/'
    | '/_with-appbar/success-video/'
    | '/_with-appbar/payment-details/'
    | '/_with-appbar/pension/'
    | '/_with-appbar/upload-identity-document/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  WithAppbarRoute: typeof WithAppbarRouteWithChildren
  homeIndexLazyRoute: typeof homeIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_with-appbar': {
      id: '/_with-appbar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WithAppbarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(home)/': {
      id: '/(home)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof homeIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_with-appbar/documents/': {
      id: '/_with-appbar/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof WithAppbarDocumentsIndexRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/error/': {
      id: '/_with-appbar/error/'
      path: '/error'
      fullPath: '/error/'
      preLoaderRoute: typeof WithAppbarErrorIndexRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/error/$paramId': {
      id: '/_with-appbar/error/$paramId'
      path: '/error/$paramId'
      fullPath: '/error/$paramId'
      preLoaderRoute: typeof WithAppbarErrorParamIdLazyRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/ok/': {
      id: '/_with-appbar/ok/'
      path: '/ok'
      fullPath: '/ok/'
      preLoaderRoute: typeof WithAppbarOkIndexRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/otp/': {
      id: '/_with-appbar/otp/'
      path: '/otp'
      fullPath: '/otp/'
      preLoaderRoute: typeof WithAppbarOtpIndexRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/payment-details/': {
      id: '/_with-appbar/payment-details/'
      path: '/payment-details'
      fullPath: '/payment-details/'
      preLoaderRoute: typeof WithAppbarPaymentDetailsIndexLazyRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/pension/': {
      id: '/_with-appbar/pension/'
      path: '/pension'
      fullPath: '/pension/'
      preLoaderRoute: typeof WithAppbarPensionIndexLazyRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/success-video/': {
      id: '/_with-appbar/success-video/'
      path: '/success-video'
      fullPath: '/success-video/'
      preLoaderRoute: typeof WithAppbarSuccessVideoIndexRouteImport
      parentRoute: typeof WithAppbarRoute
    }
    '/_with-appbar/upload-identity-document/': {
      id: '/_with-appbar/upload-identity-document/'
      path: '/upload-identity-document'
      fullPath: '/upload-identity-document/'
      preLoaderRoute: typeof WithAppbarUploadIdentityDocumentIndexLazyRouteImport
      parentRoute: typeof WithAppbarRoute
    }
  }
}

interface WithAppbarRouteChildren {
  WithAppbarErrorParamIdLazyRoute: typeof WithAppbarErrorParamIdLazyRoute
  WithAppbarDocumentsIndexRoute: typeof WithAppbarDocumentsIndexRoute
  WithAppbarErrorIndexRoute: typeof WithAppbarErrorIndexRoute
  WithAppbarOkIndexRoute: typeof WithAppbarOkIndexRoute
  WithAppbarOtpIndexRoute: typeof WithAppbarOtpIndexRoute
  WithAppbarSuccessVideoIndexRoute: typeof WithAppbarSuccessVideoIndexRoute
  WithAppbarPaymentDetailsIndexLazyRoute: typeof WithAppbarPaymentDetailsIndexLazyRoute
  WithAppbarPensionIndexLazyRoute: typeof WithAppbarPensionIndexLazyRoute
  WithAppbarUploadIdentityDocumentIndexLazyRoute: typeof WithAppbarUploadIdentityDocumentIndexLazyRoute
}

const WithAppbarRouteChildren: WithAppbarRouteChildren = {
  WithAppbarErrorParamIdLazyRoute: WithAppbarErrorParamIdLazyRoute,
  WithAppbarDocumentsIndexRoute: WithAppbarDocumentsIndexRoute,
  WithAppbarErrorIndexRoute: WithAppbarErrorIndexRoute,
  WithAppbarOkIndexRoute: WithAppbarOkIndexRoute,
  WithAppbarOtpIndexRoute: WithAppbarOtpIndexRoute,
  WithAppbarSuccessVideoIndexRoute: WithAppbarSuccessVideoIndexRoute,
  WithAppbarPaymentDetailsIndexLazyRoute:
    WithAppbarPaymentDetailsIndexLazyRoute,
  WithAppbarPensionIndexLazyRoute: WithAppbarPensionIndexLazyRoute,
  WithAppbarUploadIdentityDocumentIndexLazyRoute:
    WithAppbarUploadIdentityDocumentIndexLazyRoute,
}

const WithAppbarRouteWithChildren = WithAppbarRoute._addFileChildren(
  WithAppbarRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  WithAppbarRoute: WithAppbarRouteWithChildren,
  homeIndexLazyRoute: homeIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
